import { useState, useCallback } from 'react';

const INITIAL_MESSAGES = [
  {
    role: 'assistant',
    text: "Hi! I'm the RAAH assistant. Ask me anything about our capabilities, products, or how to get started. I can also help route your request to the right team.",
  },
];

const API_URL = process.env.REACT_APP_API_URL;

export function useChat(getToken) {
  const [messages, setMessages]   = useState(INITIAL_MESSAGES);
  const [input, setInput]         = useState('');
  const [loading, setLoading]     = useState(false);

  const sendMessage = useCallback(async (text) => {
    const trimmed = text?.trim() || input.trim();
    if (!trimmed) return;

    const userMsg = { role: 'user', text: trimmed };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);

    try {
      const token = await getToken();
      const res   = await fetch(`${API_URL}api/ask`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body:    JSON.stringify({
          messages: [...messages, userMsg].map(m => ({ role: m.role, content: m.text })),
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to get a response.');

      setMessages(prev => [...prev, { role: 'assistant', text: data.reply }]);
    } catch (err) {
      setMessages(prev => [...prev, { role: 'assistant', text: err.message, isError: true }]);
    } finally {
      setLoading(false);
    }
  }, [input, messages, getToken]);

  const handleKey = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  }, [sendMessage]);

  const reset = useCallback(() => {
    setMessages(INITIAL_MESSAGES);
    setInput('');
  }, []);

  return { messages, input, setInput, loading, sendMessage, handleKey, reset };
}